// @ts-nocheck

import { createAction } from "@reduxjs/toolkit";

export const deletePricing = createAction(
  "masterDataPricing/delete",
  function prepare(tableId) {
    return {
      payload: {
        tableId,
      },
    };
  }
);

// toggle loader
export const toggleLoading = createAction(
  "masterDataPricing/toggle-loading",
  function prepare(status) {
    return {
      payload: {
        status: status,
      },
    };
  }
);

// openModal
export const toggleModalOpen = createAction(
  "masterDataPricing/toggle-modal-open",
  function prepare(value) {
    return {
      payload: {
        openModalName: value,
      },
    };
  }
);

// closeModal
export const toggleModalClose = createAction(
  "masterDataPricing/toggle-modal-close"
);
